<template>
    <div v-if="isShowBannerCookie">
        <div class="bg-a-yellow-ffaa00 p-2.5 h-20 lg:h-12 flex">
            <div class="flex justify-center items-center m-auto">
                <div class="text-10 lg:text-12 mr-1">{{lbl.cookie.cookie_text}}
                    <router-link to="/privacy" class="underline">{{lbl.cookie.privacy}}</router-link>
                </div>
                <div class="text-10 lg:text-12 pl-8 mr-2" @click="clickAccept()">
                    <div class="bg-a-brown-502314 text-a-egg-f5ebdc px-4 py-1 rounded-20 whitespace-nowrap">{{lbl.cookie.accept_cookie}}</div>
                </div>
            </div>
        </div>
    </div>

</template>
<script>

import CookieMixin from '../../../../../mixin/CookieMixin.js';
import LocakeMixin from '../../../../../mixin/LocaleMixin.js'

export default ({
    name: 'cookieBanncer',
    mixins: [CookieMixin, LocakeMixin],
    methods: {
        clickAccept: function () {
            this.acceptCookie();
        }
    }
})
</script>
